import { Result, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

const { Text } = Typography

/**
 * Screen 8 — every 404 and every `{code: "unavailable"}` this page can hit
 * (an unknown token, a revoked link, an unverified session's `guide/` call,
 * a link that expired mid-visit) lands here, and all of them look the same:
 * no lead name, no reason, nothing that would tell a stranger holding a dead
 * link anything about who it belonged to.
 */
export function GuideUnavailable() {
  const { t } = useTranslation()

  return (
    <div data-testid={"project-education-unavailable"}>
      <Result
        status={"info"}
        title={t("projectEducation.publicPage.unavailable.title")}
        subTitle={
          <Text type={"secondary"}>
            {t("projectEducation.publicPage.unavailable.detail")}
            <br />
            {t("projectEducation.publicPage.unavailable.contact")}
          </Text>
        }
      />
    </div>
  )
}
